module.exports = __webpack_public_path__ + "static/media/logo-solmar.c72e3153.png";